import { render, staticRenderFns } from "./traffic-statistics-exceed-the-limit.vue?vue&type=template&id=2e8a513e&scoped=true&"
import script from "./traffic-statistics-exceed-the-limit.vue?vue&type=script&lang=ts&"
export * from "./traffic-statistics-exceed-the-limit.vue?vue&type=script&lang=ts&"
import style0 from "./traffic-statistics-exceed-the-limit.vue?vue&type=style&index=0&id=2e8a513e&prod&scoped=true&lang=scss&"
import style1 from "./traffic-statistics-exceed-the-limit.vue?vue&type=style&index=1&id=2e8a513e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8a513e",
  null
  
)

export default component.exports